import styled from '@emotion/styled'
import { Card, CardContent } from '@mui/material'

export const StyledAuthCard = styled(Card)`
  max-width: 500px;
  width: 100%;
  padding: 1.5rem;

  @media (max-width: 768px) {
    width: 90%;
  }
`

export const StyledAuthCardContent = styled(CardContent)`
  padding: 0 !important;
`

const AuthCard = props => {
  const { children, ...reset } = props
  return (
    <StyledAuthCard {...reset}>
      <StyledAuthCardContent>{children}</StyledAuthCardContent>
    </StyledAuthCard>
  )
}

export default AuthCard
